import { Keyframe } from "./Keyframe";
export class BooleanKeyframe extends Keyframe {
    cloneTo(destObject) {
        super.cloneTo(destObject);
        ;
        destObject.value = this.value;
    }
    clone() {
        let f = new BooleanKeyframe();
        this.cloneTo(f);
        return f;
    }
}
